import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useCallback } from 'react';
import InputField from '../InputField';
import s from './LimitedTextInputField.scss';
/** One of our standard `<input type="text" />`s.
 *
 * Limits input to a a specified length (`max`) and displays the remaining character allowance to the right of the inner input.
 */ const LimitedTextInputField = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { maxLength , value , onChange  } = _param, rest = _object_without_properties(_param, [
        "maxLength",
        "value",
        "onChange"
    ]);
    const handleOnChange = useCallback((e)=>{
        if (e.target.value.length > maxLength) {
            return;
        }
        onChange && onChange(e);
    }, [
        onChange,
        maxLength
    ]);
    return /*#__PURE__*/ React.createElement(InputField, _extends({
        type: "text",
        maxLength: maxLength,
        value: value,
        onChange: handleOnChange,
        postfix: /*#__PURE__*/ React.createElement("span", {
            className: s['postfix']
        }, maxLength - value.length)
    }, rest, {
        ref: ref
    }));
});
export default LimitedTextInputField;
